import { POPOVER_OVERLAP } from "designSystem/styles/popover-positions";
import { Box, Popover, SingleSelect } from "designSystem/index";
import React, { MouseEventHandler, useState } from "react";
import { items } from "designSystemLegacy/data";

export default () => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick: MouseEventHandler = (event) => {
		setAnchorEl(anchorEl ? null : event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const [value, setValue] = useState(items[1]);
 
	const onChangeValue = (ev, val) => {
		setValue(val);
		handleClose();
	};

	const open = !!anchorEl;
	return (
		<Box textAlign="center">
			<Box onClick={handleClick}>
				{value.name}
			</Box>
			<Popover
				anchorEl={anchorEl}
				onClose={handleClose}
				open={open}
				{...POPOVER_OVERLAP}
				PaperProps={{ style: { width: 300 } }}
				TransitionProps={{ timeout: 0 }}
			>
				<SingleSelect
					disableClearable
					inline
					onChange={onChangeValue}
					open
					options={items}
					placeHolder="Cities"
					value={value}
				/>
			</Popover>
		</Box>
	);
};

